export default __webpack_public_path__ + "static/media/cert-finance-HKIRC-sc.18d5aeea.jpg";